CKEDITOR.lang['vn'] =
  'editor': 'Bộ soạn thảo văn bản có định dạng'
  'editorPanel': 'Bảng điều khiển Rich Text Editor'
  'common':
    'editorHelp': 'Nhấn ALT + 0 để được giúp đỡ'
    'browseServer': 'Duyệt máy chủ'
    'url': 'URL'
    'protocol': 'Giao thức'
    'upload': 'Tải lên'
    'uploadSubmit': 'Tải lên máy chủ'
    'image': 'Hình ảnh'
    'flash': 'Flash'
    'form': 'Biểu mẫu'
    'checkbox': 'Nút kiểm'
    'radio': 'Nút chọn'
    'textField': 'Trường văn bản'
    'textarea': 'Vùng văn bản'
    'hiddenField': 'Trường ẩn'
    'button': 'Nút'
    'select': 'Ô chọn'
    'imageButton': 'Nút hình ảnh'
    'notSet': '<không thiết lập>'
    'id': 'Định danh'
    'name': 'Tên'
    'langDir': 'Hướng ngôn ngữ'
    'langDirLtr': 'Trái sang phải (LTR)'
    'langDirRtl': 'Phải sang trái (RTL)'
    'langCode': 'Mã ngôn ngữ'
    'longDescr': 'Mô tả URL'
    'cssClass': 'Lớp Stylesheet'
    'advisoryTitle': 'Nhan đề hướng dẫn'
    'cssStyle': 'Kiểu '
    'ok': 'Đồng ý'
    'cancel': 'Bỏ qua'
    'close': 'Đóng'
    'preview': 'Xem trước'
    'resize': 'Kéo rê để thay đổi kích cỡ'
    'generalTab': 'Tab chung'
    'advancedTab': 'Tab mở rộng'
    'validateNumberFailed': 'Giá trị này không phải là số.'
    'confirmNewPage': 'Mọi thay đổi không được lưu lại, nội dung này sẽ bị mất. Bạn có chắc chắn muốn tải một trang mới?'
    'confirmCancel': 'Một vài tùy chọn đã bị thay đổi. Bạn có chắc chắn muốn đóng hộp thoại?'
    'options': 'Tùy chọn'
    'target': 'Đích đến'
    'targetNew': 'Cửa sổ mới (_blank)'
    'targetTop': 'Cửa sổ trên cùng (_top)'
    'targetSelf': 'Tại trang (_self)'
    'targetParent': 'Cửa sổ cha (_parent)'
    'langDirLTR': 'Trái sang phải (LTR)'
    'langDirRTL': 'Phải sang trái (RTL)'
    'styles': 'Kiểu'
    'cssClasses': 'Lớp CSS'
    'width': 'Chiều rộng'
    'height': 'Chiều cao'
    'align': 'Vị trí'
    'alignLeft': 'Trái'
    'alignRight': 'Phải'
    'alignCenter': 'Giữa'
    'alignJustify': 'Sắp chữ'
    'alignTop': 'Trên'
    'alignMiddle': 'Giữa'
    'alignBottom': 'Dưới'
    'alignNone': 'Không'
    'invalidValue': 'Giá trị không hợp lệ.'
    'invalidHeight': 'Chiều cao phải là số nguyên.'
    'invalidWidth': 'Chiều rộng phải là số nguyên.'
    'invalidCssLength': 'Giá trị quy định cho trường "%1" phải là một số dương có hoặc không có một đơn vị đo CSS hợp lệ (px, %, in, cm, mm, em, ex, pt, hoặc pc).'
    'invalidHtmlLength': 'Giá trị quy định cho trường "%1" phải là một số dương có hoặc không có một đơn vị đo HTML hợp lệ (px hoặc %).'
    'invalidInlineStyle': 'Giá trị quy định cho kiểu nội tuyến phải bao gồm một hoặc nhiều dữ liệu với định dạng "tên:giá trị", cách nhau bằng dấu chấm phẩy.'
    'cssLengthTooltip': 'Nhập một giá trị theo pixel hoặc một số với một đơn vị CSS hợp lệ (px, %, in, cm, mm, em, ex, pt, hoặc pc).'
    'unavailable': '%1<span class="cke_accessibility">, không có</span>'
    'keyboard':
      '8': 'Phím Backspace'
      '13': 'Enter'
      '16': 'Shift'
      '17': 'Ctrl'
      '18': 'Alt'
      '32': 'Space'
      '35': 'End'
      '36': 'Home'
      '46': 'Xóa'
      '224': 'Command'
    'keyboardShortcut': 'Keyboard shortcut'
  'about':
    'copy': 'Bản quyền &copy; $1. Giữ toàn quyền.'
    'dlgTitle': 'Thông tin về CKEditor'
    'help': 'Kiểm tra $1 để được giúp đỡ.'
    'moreInfo': 'Vui lòng ghé thăm trang web của chúng tôi để có thông tin về giấy phép:'
    'title': 'Thông tin về CKEditor'
    'userGuide': 'Hướng dẫn sử dụng CKEditor'
  'basicstyles':
    'bold': 'Đậm'
    'italic': 'Nghiêng'
    'strike': 'Gạch xuyên ngang'
    'subscript': 'Chỉ số dưới'
    'superscript': 'Chỉ số trên'
    'underline': 'Gạch chân'
  'blockquote': 'toolbar': 'Khối trích dẫn'
  'notification': 'closed': 'Notification closed.'
  'button': 'selectedLabel': '%1 (Đã chọn)'
  'toolbar':
    'toolbarCollapse': 'Thu gọn thanh công cụ'
    'toolbarExpand': 'Mở rộng thnah công cụ'
    'toolbarGroups':
      'document': 'Tài liệu'
      'clipboard': 'Clipboard/Undo'
      'editing': 'Chỉnh sửa'
      'forms': 'Bảng biểu'
      'basicstyles': 'Kiểu cơ bản'
      'paragraph': 'Đoạn'
      'links': 'Liên kết'
      'insert': 'Chèn'
      'styles': 'Kiểu'
      'colors': 'Màu sắc'
      'tools': 'Công cụ'
    'toolbars': 'Thanh công cụ'
  'clipboard':
    'copy': 'Sao chép'
    'copyError': 'Các thiết lập bảo mật của trình duyệt không cho phép trình biên tập tự động thực thi lệnh sao chép. Hãy sử dụng bàn phím cho lệnh này (Ctrl/Cmd+C).'
    'cut': 'Cắt'
    'cutError': 'Các thiết lập bảo mật của trình duyệt không cho phép trình biên tập tự động thực thi lệnh cắt. Hãy sử dụng bàn phím cho lệnh này (Ctrl/Cmd+X).'
    'paste': 'Dán'
    'pasteNotification': 'Your browser doesn\'t allow you to paste this way. Press %1 to paste.'
  'contextmenu': 'options': 'Tùy chọn menu bổ xung'
  'elementspath':
    'eleLabel': 'Nhãn thành phần'
    'eleTitle': '%1 thành phần'
  'format':
    'label': 'Định dạng'
    'panelTitle': 'Định dạng'
    'tag_address': 'Address'
    'tag_div': 'Bình thường (DIV)'
    'tag_h1': 'Heading 1'
    'tag_h2': 'Heading 2'
    'tag_h3': 'Heading 3'
    'tag_h4': 'Heading 4'
    'tag_h5': 'Heading 5'
    'tag_h6': 'Heading 6'
    'tag_p': 'Bình thường (P)'
    'tag_pre': 'Đã thiết lập'
  'horizontalrule': 'toolbar': 'Chèn đường phân cách ngang'
  'image':
    'alt': 'Chú thích ảnh'
    'border': 'Đường viền'
    'btnUpload': 'Tải lên máy chủ'
    'button2Img': 'Bạn có muốn chuyển nút bấm bằng ảnh được chọn thành ảnh?'
    'hSpace': 'Khoảng đệm ngang'
    'img2Button': 'Bạn có muốn chuyển đổi ảnh được chọn thành nút bấm bằng ảnh?'
    'infoTab': 'Thông tin của ảnh'
    'linkTab': 'Tab liên kết'
    'lockRatio': 'Giữ nguyên tỷ lệ'
    'menu': 'Thuộc tính của ảnh'
    'resetSize': 'Kích thước gốc'
    'title': 'Thuộc tính của ảnh'
    'titleButton': 'Thuộc tính nút của ảnh'
    'upload': 'Tải lên'
    'urlMissing': 'Thiếu đường dẫn hình ảnh'
    'vSpace': 'Khoảng đệm dọc'
    'validateBorder': 'Chiều rộng của đường viền phải là một số nguyên dương'
    'validateHSpace': 'Khoảng đệm ngang phải là một số nguyên dương'
    'validateVSpace': 'Khoảng đệm dọc phải là một số nguyên dương'
  'indent':
    'indent': 'Dịch vào trong'
    'outdent': 'Dịch ra ngoài'
  'fakeobjects':
    'anchor': 'Điểm neo'
    'flash': 'Flash'
    'hiddenfield': 'Trường ẩn'
    'iframe': 'IFrame'
    'unknown': 'Đối tượng không rõ ràng'
  'link':
    'acccessKey': 'Phím hỗ trợ truy cập'
    'advanced': 'Mở rộng'
    'advisoryContentType': 'Nội dung hướng dẫn'
    'advisoryTitle': 'Nhan đề hướng dẫn'
    'anchor':
      'toolbar': 'Chèn/Sửa điểm neo'
      'menu': 'Thuộc tính điểm neo'
      'title': 'Thuộc tính điểm neo'
      'name': 'Tên của điểm neo'
      'errorName': 'Hãy nhập vào tên của điểm neo'
      'remove': 'Xóa neo'
    'anchorId': 'Theo định danh thành phần'
    'anchorName': 'Theo tên điểm neo'
    'charset': 'Bảng mã của tài nguyên được liên kết đến'
    'cssClasses': 'Lớp Stylesheet'
    'download': 'Force Download'
    'displayText': 'Display Text'
    'emailAddress': 'Thư điện tử'
    'emailBody': 'Nội dung thông điệp'
    'emailSubject': 'Tiêu đề thông điệp'
    'id': 'Định danh'
    'info': 'Thông tin liên kết'
    'langCode': 'Mã ngôn ngữ'
    'langDir': 'Hướng ngôn ngữ'
    'langDirLTR': 'Trái sang phải (LTR)'
    'langDirRTL': 'Phải sang trái (RTL)'
    'menu': 'Sửa liên kết'
    'name': 'Tên'
    'noAnchors': '(Không có điểm neo nào trong tài liệu)'
    'noEmail': 'Hãy đưa vào địa chỉ thư điện tử'
    'noUrl': 'Hãy đưa vào đường dẫn liên kết (URL)'
    'other': '<khác>'
    'popupDependent': 'Phụ thuộc (Netscape)'
    'popupFeatures': 'Đặc điểm của cửa sổ Popup'
    'popupFullScreen': 'Toàn màn hình (IE)'
    'popupLeft': 'Vị trí bên trái'
    'popupLocationBar': 'Thanh vị trí'
    'popupMenuBar': 'Thanh Menu'
    'popupResizable': 'Có thể thay đổi kích cỡ'
    'popupScrollBars': 'Thanh cuộn'
    'popupStatusBar': 'Thanh trạng thái'
    'popupToolbar': 'Thanh công cụ'
    'popupTop': 'Vị trí phía trên'
    'rel': 'Quan hệ'
    'selectAnchor': 'Chọn một điểm neo'
    'styles': 'Kiểu (style)'
    'tabIndex': 'Chỉ số của Tab'
    'target': 'Đích'
    'targetFrame': '<khung>'
    'targetFrameName': 'Tên khung đích'
    'targetPopup': '<cửa sổ popup>'
    'targetPopupName': 'Tên cửa sổ Popup'
    'title': 'Liên kết'
    'toAnchor': 'Neo trong trang này'
    'toEmail': 'Thư điện tử'
    'toUrl': 'URL'
    'toolbar': 'Chèn/Sửa liên kết'
    'type': 'Kiểu liên kết'
    'unlink': 'Xoá liên kết'
    'upload': 'Tải lên'
  'list':
    'bulletedlist': 'Chèn/Xoá Danh sách không thứ tự'
    'numberedlist': 'Chèn/Xoá Danh sách có thứ tự'
  'magicline': 'title': 'Chèn đoạn vào đây'
  'maximize':
    'maximize': 'Phóng to tối đa'
    'minimize': 'Thu nhỏ'
  'pastetext':
    'button': 'Dán theo định dạng văn bản thuần'
    'pasteNotification': 'Your browser does not allow you to paste plain text this way. Press %1 to paste.'
  'pastefromword':
    'confirmCleanup': 'Văn bản bạn muốn dán có kèm định dạng của Word. Bạn có muốn loại bỏ định dạng Word trước khi dán?'
    'error': 'Không thể để làm sạch các dữ liệu dán do một lỗi nội bộ'
    'title': 'Dán với định dạng Word'
    'toolbar': 'Dán với định dạng Word'
  'removeformat': 'toolbar': 'Xoá định dạng'
  'sourcearea': 'toolbar': 'Mã HTML'
  'specialchar':
    'options': 'Tùy chọn các ký tự đặc biệt'
    'title': 'Hãy chọn ký tự đặc biệt'
    'toolbar': 'Chèn ký tự đặc biệt'
  'scayt':
    'btn_about': 'Thông tin về SCAYT'
    'btn_dictionaries': 'Từ điển'
    'btn_disable': 'Tắt SCAYT'
    'btn_enable': 'Bật SCAYT'
    'btn_langs': 'Ngôn ngữ'
    'btn_options': 'Tùy chọn'
    'text_title': 'Kiểm tra chính tả ngay khi gõ chữ (SCAYT)'
  'stylescombo':
    'label': 'Kiểu'
    'panelTitle': 'Phong cách định dạng'
    'panelTitle1': 'Kiểu khối'
    'panelTitle2': 'Kiểu trực tiếp'
    'panelTitle3': 'Kiểu đối tượng'
  'table':
    'border': 'Kích thước đường viền'
    'caption': 'Đầu đề'
    'cell':
      'menu': 'Ô'
      'insertBefore': 'Chèn ô Phía trước'
      'insertAfter': 'Chèn ô Phía sau'
      'deleteCell': 'Xoá ô'
      'merge': 'Kết hợp ô'
      'mergeRight': 'Kết hợp sang phải'
      'mergeDown': 'Kết hợp xuống dưới'
      'splitHorizontal': 'Phân tách ô theo chiều ngang'
      'splitVertical': 'Phân tách ô theo chiều dọc'
      'title': 'Thuộc tính của ô'
      'cellType': 'Kiểu của ô'
      'rowSpan': 'Kết hợp hàng'
      'colSpan': 'Kết hợp cột'
      'wordWrap': 'Chữ liền hàng'
      'hAlign': 'Canh lề ngang'
      'vAlign': 'Canh lề dọc'
      'alignBaseline': 'Đường cơ sở'
      'bgColor': 'Màu nền'
      'borderColor': 'Màu viền'
      'data': 'Dữ liệu'
      'header': 'Đầu đề'
      'yes': 'Có'
      'no': 'Không'
      'invalidWidth': 'Chiều rộng của ô phải là một số nguyên.'
      'invalidHeight': 'Chiều cao của ô phải là một số nguyên.'
      'invalidRowSpan': 'Số hàng kết hợp phải là một số nguyên.'
      'invalidColSpan': 'Số cột kết hợp phải là một số nguyên.'
      'chooseColor': 'Chọn màu'
    'cellPad': 'Khoảng đệm giữ ô và nội dung'
    'cellSpace': 'Khoảng cách giữa các ô'
    'column':
      'menu': 'Cột'
      'insertBefore': 'Chèn cột phía trước'
      'insertAfter': 'Chèn cột phía sau'
      'deleteColumn': 'Xoá cột'
    'columns': 'Số cột'
    'deleteTable': 'Xóa bảng'
    'headers': 'Đầu đề'
    'headersBoth': 'Cả hai'
    'headersColumn': 'Cột đầu tiên'
    'headersNone': 'Không có'
    'headersRow': 'Hàng đầu tiên'
    'invalidBorder': 'Kích cỡ của đường biên phải là một số nguyên.'
    'invalidCellPadding': 'Khoảng đệm giữa ô và nội dung phải là một số nguyên.'
    'invalidCellSpacing': 'Khoảng cách giữa các ô phải là một số nguyên.'
    'invalidCols': 'Số lượng cột phải là một số lớn hơn 0.'
    'invalidHeight': 'Chiều cao của bảng phải là một số nguyên.'
    'invalidRows': 'Số lượng hàng phải là một số lớn hơn 0.'
    'invalidWidth': 'Chiều rộng của bảng phải là một số nguyên.'
    'menu': 'Thuộc tính bảng'
    'row':
      'menu': 'Hàng'
      'insertBefore': 'Chèn hàng phía trước'
      'insertAfter': 'Chèn hàng phía sau'
      'deleteRow': 'Xoá hàng'
    'rows': 'Số hàng'
    'summary': 'Tóm lược'
    'title': 'Thuộc tính bảng'
    'toolbar': 'Bảng'
    'widthPc': 'Phần trăm (%)'
    'widthPx': 'Điểm ảnh (px)'
    'widthUnit': 'Đơn vị'
  'undo':
    'redo': 'Làm lại thao tác'
    'undo': 'Khôi phục thao tác'
  'wsc':
    'btnIgnore': 'Bỏ qua'
    'btnIgnoreAll': 'Bỏ qua tất cả'
    'btnReplace': 'Thay thế'
    'btnReplaceAll': 'Thay thế tất cả'
    'btnUndo': 'Phục hồi lại'
    'changeTo': 'Chuyển thành'
    'errorLoading': 'Lỗi khi đang nạp dịch vụ ứng dụng: %s.'
    'ieSpellDownload': 'Chức năng kiểm tra chính tả chưa được cài đặt. Bạn có muốn tải về ngay bây giờ?'
    'manyChanges': 'Hoàn tất kiểm tra chính tả: %1 từ đã được thay đổi'
    'noChanges': 'Hoàn tất kiểm tra chính tả: Không có từ nào được thay đổi'
    'noMispell': 'Hoàn tất kiểm tra chính tả: Không có lỗi chính tả'
    'noSuggestions': '- Không đưa ra gợi ý về từ -'
    'notAvailable': 'Xin lỗi, dịch vụ này hiện tại không có.'
    'notInDic': 'Không có trong từ điển'
    'oneChange': 'Hoàn tất kiểm tra chính tả: Một từ đã được thay đổi'
    'progress': 'Đang tiến hành kiểm tra chính tả...'
    'title': 'Kiểm tra chính tả'
    'toolbar': 'Kiểm tra chính tả'



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/lang/vn.coffee